// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SplatRouteImport } from './routes/$'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PortalIndexRouteImport } from './routes/portal/index'
import { Route as SignTokenRouteImport } from './routes/sign/$token'
import { Route as SignUpSplatRouteImport } from './routes/sign-up.$'
import { Route as SignInSplatRouteImport } from './routes/sign-in.$'
import { Route as PortalParentsRouteImport } from './routes/portal/parents'
import { Route as PortalOfficeRouteImport } from './routes/portal/office'
import { Route as PortalEmployeesRouteImport } from './routes/portal/employees'
import { Route as PortalLayoutRouteImport } from './routes/portal/_layout'
import { Route as PortalManagersRouteRouteImport } from './routes/portal/managers/route'
import { Route as PortalManagersIndexRouteImport } from './routes/portal/managers/index'
import { Route as PortalManagersSigningRouteImport } from './routes/portal/managers/signing'
import { Route as PortalManagersShiftsRouteImport } from './routes/portal/managers/shifts'
import { Route as PortalManagersSettingsRouteImport } from './routes/portal/managers/settings'
import { Route as PortalManagersEmploymentRouteImport } from './routes/portal/managers/employment'
import { Route as PortalManagersClassesRouteImport } from './routes/portal/managers/classes'
import { Route as PortalManagersAccountsRouteImport } from './routes/portal/managers/accounts'
import { Route as PortalManagersHrIndexRouteImport } from './routes/portal/managers/hr/index'
import { Route as PortalManagersHrShiftsRouteImport } from './routes/portal/managers/hr/shifts'
import { Route as PortalManagersHrPayrollRouteImport } from './routes/portal/managers/hr/payroll'
import { Route as PortalManagersHrEmployeesRouteImport } from './routes/portal/managers/hr/employees'
import { Route as PortalManagersHrAttendanceRouteImport } from './routes/portal/managers/hr/attendance'

const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const PortalIndexRoute = PortalIndexRouteImport.update({
            id: '/portal/',path: '/portal/',getParentRoute: () => rootRouteImport
          })
const SignTokenRoute = SignTokenRouteImport.update({
            id: '/sign/$token',path: '/sign/$token',getParentRoute: () => rootRouteImport
          })
const SignUpSplatRoute = SignUpSplatRouteImport.update({
            id: '/sign-up/$',path: '/sign-up/$',getParentRoute: () => rootRouteImport
          })
const SignInSplatRoute = SignInSplatRouteImport.update({
            id: '/sign-in/$',path: '/sign-in/$',getParentRoute: () => rootRouteImport
          })
const PortalParentsRoute = PortalParentsRouteImport.update({
            id: '/portal/parents',path: '/portal/parents',getParentRoute: () => rootRouteImport
          })
const PortalOfficeRoute = PortalOfficeRouteImport.update({
            id: '/portal/office',path: '/portal/office',getParentRoute: () => rootRouteImport
          })
const PortalEmployeesRoute = PortalEmployeesRouteImport.update({
            id: '/portal/employees',path: '/portal/employees',getParentRoute: () => rootRouteImport
          })
const PortalLayoutRoute = PortalLayoutRouteImport.update({
            id: '/portal/_layout',path: '/portal',getParentRoute: () => rootRouteImport
          })
const PortalManagersRouteRoute = PortalManagersRouteRouteImport.update({
            id: '/portal/managers',path: '/portal/managers',getParentRoute: () => rootRouteImport
          })
const PortalManagersIndexRoute = PortalManagersIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PortalManagersRouteRoute
          })
const PortalManagersSigningRoute = PortalManagersSigningRouteImport.update({
            id: '/signing',path: '/signing',getParentRoute: () => PortalManagersRouteRoute
          })
const PortalManagersShiftsRoute = PortalManagersShiftsRouteImport.update({
            id: '/shifts',path: '/shifts',getParentRoute: () => PortalManagersRouteRoute
          })
const PortalManagersSettingsRoute = PortalManagersSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => PortalManagersRouteRoute
          })
const PortalManagersEmploymentRoute = PortalManagersEmploymentRouteImport.update({
            id: '/employment',path: '/employment',getParentRoute: () => PortalManagersRouteRoute
          })
const PortalManagersClassesRoute = PortalManagersClassesRouteImport.update({
            id: '/classes',path: '/classes',getParentRoute: () => PortalManagersRouteRoute
          })
const PortalManagersAccountsRoute = PortalManagersAccountsRouteImport.update({
            id: '/accounts',path: '/accounts',getParentRoute: () => PortalManagersRouteRoute
          })
const PortalManagersHrIndexRoute = PortalManagersHrIndexRouteImport.update({
            id: '/hr/',path: '/hr/',getParentRoute: () => PortalManagersRouteRoute
          })
const PortalManagersHrShiftsRoute = PortalManagersHrShiftsRouteImport.update({
            id: '/hr/shifts',path: '/hr/shifts',getParentRoute: () => PortalManagersRouteRoute
          })
const PortalManagersHrPayrollRoute = PortalManagersHrPayrollRouteImport.update({
            id: '/hr/payroll',path: '/hr/payroll',getParentRoute: () => PortalManagersRouteRoute
          })
const PortalManagersHrEmployeesRoute = PortalManagersHrEmployeesRouteImport.update({
            id: '/hr/employees',path: '/hr/employees',getParentRoute: () => PortalManagersRouteRoute
          })
const PortalManagersHrAttendanceRoute = PortalManagersHrAttendanceRouteImport.update({
            id: '/hr/attendance',path: '/hr/attendance',getParentRoute: () => PortalManagersRouteRoute
          })





const PortalManagersRouteRouteChildren = {
  PortalManagersAccountsRoute: PortalManagersAccountsRoute,PortalManagersClassesRoute: PortalManagersClassesRoute,PortalManagersEmploymentRoute: PortalManagersEmploymentRoute,PortalManagersSettingsRoute: PortalManagersSettingsRoute,PortalManagersShiftsRoute: PortalManagersShiftsRoute,PortalManagersSigningRoute: PortalManagersSigningRoute,PortalManagersIndexRoute: PortalManagersIndexRoute,PortalManagersHrAttendanceRoute: PortalManagersHrAttendanceRoute,PortalManagersHrEmployeesRoute: PortalManagersHrEmployeesRoute,PortalManagersHrPayrollRoute: PortalManagersHrPayrollRoute,PortalManagersHrShiftsRoute: PortalManagersHrShiftsRoute,PortalManagersHrIndexRoute: PortalManagersHrIndexRoute
}

const PortalManagersRouteRouteWithChildren = PortalManagersRouteRoute._addFileChildren(PortalManagersRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,PortalManagersRouteRoute: PortalManagersRouteRouteWithChildren,PortalLayoutRoute: PortalLayoutRoute,PortalEmployeesRoute: PortalEmployeesRoute,PortalOfficeRoute: PortalOfficeRoute,PortalParentsRoute: PortalParentsRoute,SignInSplatRoute: SignInSplatRoute,SignUpSplatRoute: SignUpSplatRoute,SignTokenRoute: SignTokenRoute,PortalIndexRoute: PortalIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)